import React from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// import SettingsIcon from "@mui/icons-material/Settings";
import { Box, Button, Stack, Typography } from "@mui/material";
import type { ArticleRow } from "store/types/news";
import { formatNewsDate } from "utils/format-news-date";

const logoInitials = (name: string): string => {
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return name.slice(0, 2).toUpperCase();
  return (words[0][0] + (words[1][0] || "")).toUpperCase();
};

type Props = {
  articles: ArticleRow[];
  onDealCoverage?: (dealId: string) => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ArticleList: React.FC<Props> = ({ articles, onDealCoverage }) => {
  return (
    <Stack direction="column" gap={0}>
      {articles.map((article, idx) => {
        return (
          <Stack
            key={idx}
            direction="column"
            gap={0}
            sx={{
              bgcolor: "#fff",
              my: "6px",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "divider",
              p: "14px 16px",
              transition: "border-color 0.12s, box-shadow 0.12s",
              "&:hover": {
                borderColor: "#c0cdd8",
                boxShadow: "0 2px 8px rgba(7,31,53,0.06)"
              }
            }}
          >
            <Stack direction="row" gap="11px" mb="10px">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "8px",
                  bgcolor: "primary.main",
                  color: "primary.contrastText"
                }}
              >
                {logoInitials(article.category)}
              </Stack>
              <Stack
                direction="column"
                justifyContent="center"
                sx={{
                  flex: 1,
                  minWidth: 0
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#071f35",
                    lineHeight: 1.2,
                    mb: "2px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {article.category}
                </Typography>
                <Stack
                  direction="row"
                  sx={{
                    fontSize: 11,
                    color: "#797979",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <Box component="span">{article.source}</Box>
                  <Box
                    component="span"
                    sx={{
                      width: 3,
                      height: 3,
                      borderRadius: "50%",
                      bgcolor: "#92a7bc",
                      display: "inline-block",
                      flexShrink: 0
                    }}
                  />
                  <Box component="span">{formatNewsDate(article.published_at)}</Box>
                </Stack>
              </Stack>
            </Stack>

            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#071f35",
                mb: "2px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {article.title}
            </Typography>

            <Typography
              sx={{
                fontSize: 12,
                color: "secondary.main",
                mb: 0
              }}
            >
              {article.summary}
            </Typography>

            <Stack
              direction="row"
              justifyContent="space-between"
              //reverse order
              flexDirection="row-reverse"
              alignItems="center"
              sx={{
                mt: "9px",
                pt: "9px",
                borderTop: "1px solid",
                borderColor: "divider"
              }}
            >
              {/* {article.type === "deal" && onDealCoverage && (
                <Button
                  size="sm"
                  variant="text"
                  // onClick={() => article?.dealId && onDealCoverage(article.dealId || "")}
                  sx={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: "secondary.main",
                    textDecoration: "none",
                    gap: "2px",
                    "&:hover": {
                      color: "#26a6ae"
                    }
                  }}
                >
                  <SettingsIcon sx={{ fontSize: 13 }} />
                  Coverage settings
                </Button>
              )} */}
              <Button
                component="a"
                href={article.url || undefined}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<KeyboardArrowRightIcon sx={{ fontSize: 13 }} />}
                size="sm"
                variant="text"
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#26a6ae"
                }}
              >
                See item
              </Button>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};
